import React from "react";
import MobileRecording from "./mobileRecording";
import MobileGroupButton from "../button/mobileGroupButton";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import {getAlphaNumberStandardArray, injectRemoveTableHeader} from "../../../utils/mobileUtils";
import ReactTable from "react-table";
import "react-table/react-table.css";
// import withFixedColumns from "react-table-hoc-fixed-columns";
// import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingAlphaNumberBlock extends MobileRecording {
    constructor(props) {
        super();
    }

    state = {
        charactersAt1: getAlphaNumberStandardArray("1"),
        charactersAt2: getAlphaNumberStandardArray("2"),
        charactersAt3: getAlphaNumberStandardArray("3"),
        charactersAt4: getAlphaNumberStandardArray("4"),
        charactersAt5: getAlphaNumberStandardArray("5"),
        charactersAt6: getAlphaNumberStandardArray("6"),
        charactersAt7: getAlphaNumberStandardArray("7"),
        charactersAt8: getAlphaNumberStandardArray("8"),
        charactersAt9: getAlphaNumberStandardArray("9"),
        charactersAt0: getAlphaNumberStandardArray("0")
    };

    componentDidMount = () => {
        const {currentRecordingFlowChart} = this.props;

        let newCharactersAt1 = [...this.state.charactersAt1];
        let newCharactersAt2 = [...this.state.charactersAt2];
        let newCharactersAt3 = [...this.state.charactersAt3];
        let newCharactersAt4 = [...this.state.charactersAt4];
        let newCharactersAt5 = [...this.state.charactersAt5];
        let newCharactersAt6 = [...this.state.charactersAt6];
        let newCharactersAt7 = [...this.state.charactersAt7];
        let newCharactersAt8 = [...this.state.charactersAt8];
        let newCharactersAt9 = [...this.state.charactersAt9];
        let newCharactersAt0 = [...this.state.charactersAt0];

        if (
            currentRecordingFlowChart &&
            currentRecordingFlowChart.alphaNumberBlock
        ) {
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt1)
                newCharactersAt1 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt1;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt2)
                newCharactersAt2 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt2;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt3)
                newCharactersAt3 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt3;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt4)
                newCharactersAt4 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt4;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt5)
                newCharactersAt5 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt5;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt6)
                newCharactersAt6 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt6;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt7)
                newCharactersAt7 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt7;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt8)
                newCharactersAt8 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt8;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt9)
                newCharactersAt9 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt9;
            if (currentRecordingFlowChart.alphaNumberBlock.charactersAt0)
                newCharactersAt0 =
                    currentRecordingFlowChart.alphaNumberBlock.charactersAt0;
        }

        this.setState({
            charactersAt1: newCharactersAt1,
            charactersAt2: newCharactersAt2,
            charactersAt3: newCharactersAt3,
            charactersAt4: newCharactersAt4,
            charactersAt5: newCharactersAt5,
            charactersAt6: newCharactersAt6,
            charactersAt7: newCharactersAt7,
            charactersAt8: newCharactersAt8,
            charactersAt9: newCharactersAt9,
            charactersAt0: newCharactersAt0
        });
    };

    getTitle = titles => {
        let text = "";
        for (const item of titles) {
            text += item.title.text;
        }
        return text;
    };

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData
        } = this.props;

        let data = [];
        let columns = [];

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        const selectionDisabled = this.isSelectionDisabled(
            currentRecordingFlowChart,
            recordData
        );

        columns = [
            {
                Header: (
                    <div>
                        <h3>{currentFlowChart.title.text}</h3>
                        <h4>
                            {currentRecordingFlowChart.title.text +
                            ": " +
                            recordData.fields[
                                `${currentRecordingFlowChart.tableField}Display`
                                ]}
                        </h4>
                    </div>
                ),
                fixed: "left",
                columns: [
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <MobileGroupButton
                                id={original.id * 10 + 1}
                                value={original.id}
                                onClick={this.onChange}
                                disabled={selectionDisabled && !original.title1AlwaysEnabled}
                                title={this.getTitle(original.titles1)}
                                titles={original.titles1}
                            />
                        ),
                        Footer: () => (
                            <MobileContinueButton
                                onClick={() => {
                                    this.onFieldContinue();
                                }}
                                disabled={continueButtonDisabled}
                                title={{text: "Weiter"}}
                            />
                        )
                    },
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <MobileGroupButton
                                id={original.id * 10 + 2}
                                value={original.id}
                                onClick={this.onChange}
                                disabled={selectionDisabled && !original.title2AlwaysEnabled}
                                title={this.getTitle(original.titles2)}
                                titles={original.titles2}
                            />
                        )
                    },
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <MobileGroupButton
                                id={original.id * 10 + 3}
                                value={original.id}
                                onClick={this.onChange}
                                disabled={selectionDisabled && !original.title3AlwaysEnabled}
                                title={this.getTitle(original.titles3)}
                                titles={original.titles3}
                            />
                        ),
                        Footer: () => (
                            <div className="text-right">
                                <MobileCancelButton
                                    onClick={() => {
                                        this.onFieldCancel();
                                    }}
                                    title={{text: "Abbr."}}
                                />
                            </div>
                        )
                    }
                ]
            }
        ];

        data.push({
            id: 0,
            titles1: this.state.charactersAt1,
            titles2: this.state.charactersAt2,
            titles3: this.state.charactersAt3
        });
        data.push({
            id: 1,
            titles1: this.state.charactersAt4,
            titles2: this.state.charactersAt5,
            titles3: this.state.charactersAt6
        });
        data.push({
            id: 2,
            titles1: this.state.charactersAt7,
            titles2: this.state.charactersAt8,
            titles3: this.state.charactersAt9
        });
        data.push({
            id: 3,
            titles1: [
                {
                    title: {
                        text: "CLR",
                        style: {}
                    }
                }
            ],
            title1AlwaysEnabled: true,
            titles2: this.state.charactersAt0,
            titles3: [
                {
                    title: {
                        text: "BS",
                        style: {}
                    }
                }
            ],
            title3AlwaysEnabled: true
        });

        // withFixedColumns funktioniert nicht!
        // const ReactTableFixedColumns = withFixedColumns(ReactTable);

        return (
            <React.Fragment>
                {/* <ReactTableFixedColumns */}
                <ReactTable
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    getTheadThProps={injectRemoveTableHeader}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingAlphaNumberBlock;
